module.exports = __webpack_public_path__ + "img/LogoFooter33.fece4412.svg";